export default __webpack_public_path__ + "static/media/behind_the_science_image.70fe31fb.gif";